/**
 * PrivacyPresenter
 * --
 */
import React from 'react';
import { HtmlContent } from 'components';

const PrivacyPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { data } = props;

  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <div style={{ padding: '80px 0px', maxWidth: 1200, margin: '0 auto' }}>
      <h1 style={{ fontSize: 30, textAlign: 'center', marginBottom: 30 }}>
        {data?.provision_title}
      </h1>
      <div
        style={{
          width: '100%',
          border: '1px solid #F5F5F5',
          padding: 20,
          lineHeight: '175%',
          wordBreak: 'keep-all',
          fontSize: 15,
        }}
      >
        <HtmlContent content={data?.provision_content} />
      </div>
    </div>
  );
};

export default PrivacyPresenter;
